import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { zodFlavorId } from "../ids.mjs";
import { defineFirestoreCollection } from "../firebaseCollectionSchema.mjs";
import { vendorSyncOpOperationSchema, vendorSyncOpStatusSchema } from "./syncPrimitives.mjs";
import { z as z$1 } from "zod";

// src/models/vendorSync/vendorSync.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/**
* Write-once apply result under `{objectCollection}/{syncId}/ops/{eventId}`.
* Prefer op id = eventId; never mutate after create.
*/
const vendorSyncOpSchema = z$1.object({
	id: zodFlavorId(),
	eventId: z$1.string().min(1),
	operation: vendorSyncOpOperationSchema,
	status: vendorSyncOpStatusSchema,
	reason: z$1.string().optional(),
	beforeHash: z$1.string().optional(),
	afterHash: z$1.string().optional(),
	changedPaths: z$1.array(z$1.string()).optional(),
	vendorNativeId: z$1.string().optional(),
	completedAt: firestoreDate,
	error: z$1.string().optional()
});
/** Shared write-once ops subcollection under all L4 vendor sync parents. */
const VendorSyncOps = defineFirestoreCollection("ops", vendorSyncOpSchema);

export { VendorSyncOps, vendorSyncOpSchema };
//# sourceMappingURL=vendorSync.mjs.map